import { isFuture } from "date-fns";

import { Event } from "@hubcapp/graphql";

/**
 * This makes an assumption that the lessons are sorted in date order ascending
 * @param lessons An array of sorted lessons that may be in the past or future
 */
export const getNextLesson = (lessons: Event[]): Event | undefined => {
  let nextLesson: Event | undefined;

  const upcomingLessons = lessons.filter(
    (lesson: Pick<Event, "startDateTime">) =>
      isFuture(new Date(lesson.startDateTime)),
  );

  if (upcomingLessons.length) {
    nextLesson = upcomingLessons[0];
  }

  return nextLesson;
};
